import React, { useEffect, useState } from 'react';
import { Divider } from 'antd';

import { translate } from '@portal/services/i18n';
import { RightOutlined } from '@ant-design/icons';

import OnboardingDocumentPhotoModal from '../OnboardingDocumentPhotoModal/OnboardingDocumentPhotoModal';

import Digital from '@portal/assets/svg/onboarding-icons/ic_digital.svg?react';
import Correct from '@portal/assets/svg/onboarding-icons/ic_correct.svg?react';
import { DocumentType } from '@portal/enum/documentType';
import { onboarding } from '@portal/config/app.json';
import { validateOnboardingDocument } from '@portal/utils/validate';
interface IProps {
  documentType: number;
  setDocumentType(value: number);
  setFileSelectedDigitalCnh: (value: File | null) => void;
  setFileSelectedCnh: (value: File | null) => void;
  setFileSelectedRgFront: (value: File | null) => void;
  setFileSelectedRgBack: (value: File | null) => void;
  setFileSelectedCnhBack?: (value: File | null) => void;
  isUserMinor?: boolean;
}

const OnboardingDocumentPhoto = ({
  documentType,
  setDocumentType,
  setFileSelectedDigitalCnh,
  setFileSelectedCnh,
  setFileSelectedCnhBack,
  setFileSelectedRgFront,
  setFileSelectedRgBack,
  isUserMinor,
}: IProps) => {
  const [modal, setModal] = useState(false);
  const [onFileChangeCnhModal, setFileSelectedCnhModal] = useState<File | null>(
    null
  );
  const [onFileChangeDigitalCnhModal, setFileSelectedDigitalCnhModal] =
    useState<File | null>(null);
  const [onFileChangeCnhModalBack, setFileSelectedCnhModalBack] =
    useState<File | null>(null);
  const [onFileChangeRgFrontModal, setFileSelectedRgFrontModal] =
    useState<File | null>(null);
  const [onFileChangeRgBackModal, setFileSelectedRgBackModal] =
    useState<File | null>(null);

  const validateFile = (file) => {
    if (
      file.target.files[0]?.type !== 'image/png' &&
      file.target.files[0]?.type !== 'image/jpeg' &&
      file.target.files[0]?.type !== 'application/pdf'
    ) {
      return false;
    }
    return true;
  };

  const onFileChangeCnh = (file: React.ChangeEvent<HTMLInputElement>) => {
    if (!file.currentTarget?.files) {
      return;
    }

    if (!validateOnboardingDocument(file)) {
      return;
    }

    if (validateFile(file)) {
      setFileSelectedCnh(file.currentTarget.files[0]);
      setFileSelectedCnhModal(file.currentTarget.files[0]);
    }
  };

  const onFileChangeDigitalCnh = (
    file: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (!file.currentTarget?.files) {
      return;
    }

    if (!validateOnboardingDocument(file)) {
      return;
    }

    if (validateFile(file)) {
      setFileSelectedDigitalCnh(file.currentTarget.files[0]);
      setFileSelectedDigitalCnhModal(file.currentTarget.files[0]);
    }
  };

  const onFileChangeCnhBack = (file: React.ChangeEvent<HTMLInputElement>) => {
    if (!file.currentTarget?.files) {
      return;
    }

    if (!validateOnboardingDocument(file)) {
      return;
    }

    if (
      validateFile(file) &&
      setFileSelectedCnhBack &&
      onboarding.driversLicense
    ) {
      setFileSelectedCnhBack(file.currentTarget.files[0]);
      setFileSelectedCnhModalBack(file.currentTarget.files[0]);
    }
  };

  const onFileChangeRgFront = (file: React.ChangeEvent<HTMLInputElement>) => {
    if (!file.currentTarget?.files) {
      return;
    }

    if (!validateOnboardingDocument(file)) {
      return;
    }

    if (validateFile(file)) {
      setFileSelectedRgFront(file.currentTarget.files[0]);
      setFileSelectedRgFrontModal(file.currentTarget.files[0]);
    }
  };

  const onFileChangeRgBack = (file: React.ChangeEvent<HTMLInputElement>) => {
    if (!file.currentTarget?.files) {
      return;
    }

    if (!validateOnboardingDocument(file)) {
      return;
    }

    if (validateFile(file)) {
      setFileSelectedRgBack(file.currentTarget.files[0]);
      setFileSelectedRgBackModal(file.currentTarget.files[0]);
    }
  };

  const cleanFileCnh = () => {
    setFileSelectedCnh(null);
    setFileSelectedCnhModal(null);
  };

  const cleanFileCnhBack = () => {
    if (setFileSelectedCnhBack) {
      setFileSelectedCnhBack(null);
    }
    setFileSelectedCnhModalBack(null);
  };

  const cleanFileRgBack = () => {
    setFileSelectedRgBack(null);
    setFileSelectedRgBackModal(null);
  };

  const cleanFileRgFront = () => {
    setFileSelectedRgFront(null);
    setFileSelectedRgFrontModal(null);
  };

  useEffect(() => {
    if (isUserMinor) {
      setDocumentType(DocumentType.RG);
    }
  }, [setDocumentType, isUserMinor]);

  return (
    <>
      <div className="action-display" onClick={() => setModal(true)}>
        <div className="action-display__action">
          <div className="action-display__action__options">
            <Digital
              width={30}
              height={25}
              className="action-display__action__options__icon"
            />
            <div className="action-display__action__options__container">
              <p className="action-display__action__options__title">
                {translate('PAGES.AUTH.REGISTER.ONBOARD.PF.DOCUMENT.LABEL')}
              </p>
              <p className="action-display__action__options__text">
                {translate(
                  'PAGES.AUTH.REGISTER.ONBOARD.PF.DOCUMENT.FORM.LABEL'
                )}
              </p>
            </div>
          </div>

          <span>
            {(documentType === DocumentType.CNH &&
              (onboarding.requireTwodriverLicensePictures
                ? !!onFileChangeCnhModal && !!onFileChangeCnhModalBack
                : !!onFileChangeCnhModal)) ||
            (documentType === DocumentType.RG &&
              onFileChangeRgFrontModal &&
              onFileChangeRgBackModal) ||
            (documentType === DocumentType.DIGITAL_CNH &&
              onFileChangeDigitalCnhModal) ? (
              <Correct width={25} height={25} />
            ) : (
              <RightOutlined
                style={{
                  color: 'black',
                  fontSize: 20,
                }}
              />
            )}
          </span>
        </div>
        <Divider />
      </div>
      {modal ? (
        <OnboardingDocumentPhotoModal
          documentType={documentType}
          setDocumentType={setDocumentType}
          onFileChangeCnh={onFileChangeCnh}
          onFileChangeDigitalCnh={onFileChangeDigitalCnh}
          onFileChangeCnhBack={onFileChangeCnhBack}
          onFileChangeRgBack={onFileChangeRgBack}
          onFileChangeRgFront={onFileChangeRgFront}
          modal={modal}
          cleanFileCnh={cleanFileCnh}
          cleanFileCnhBack={cleanFileCnhBack}
          cleanFileRgBack={cleanFileRgBack}
          cleanFileRgFront={cleanFileRgFront}
          onCancel={() => setModal(false)}
          onFileChangeDigitalCnhModal={onFileChangeDigitalCnhModal}
          onFileChangeCnhModal={onFileChangeCnhModal}
          onFileChangeCnhModalBack={onFileChangeCnhModalBack}
          onFileChangeRgFrontModal={onFileChangeRgFrontModal}
          onFileChangeRgBackModal={onFileChangeRgBackModal}
          isUserMinor={isUserMinor}
          sendType="photo"
        />
      ) : null}
    </>
  );
};

export default OnboardingDocumentPhoto;
